// axios-config.js
import axios from 'axios';

const apiEndpoint = process.env.REACT_APP_SERVER || '/api/';

const axiosInstance = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true
});

// Intercept 401 responses to force logout across all tabs
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data?.error === 'Authentication required' &&
      !error.config.url.includes('login/login') &&
      !error.config.url.includes('login/logout')
    ) {
      // Clear all local auth state
      localStorage.clear();
      // Redirect to login page
      window.location.href = '/login';
    }
    // Redirect to trial-expired page on account inactive responses
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data &&
      error.response.data.code &&
      ['trial_expired', 'service_disabled', 'account_suspended', 'account_disabled', 'account_archived'].includes(error.response.data.code) &&
      !window.location.pathname.includes('/trial-expired')
    ) {
      window.location.href = '/trial-expired';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
